<template>
  <div class="register-container">
    <div class="register-card">
      <div class="register-header">
        <h1>💡 Idea Note</h1>
        <p>创建你的笔记空间</p>
      </div>
      
      <form @submit.prevent="handleRegister" class="register-form">
        <div class="form-group">
          <label for="username">用户名</label>
          <input 
            type="text" 
            id="username" 
            v-model="form.username" 
            placeholder="请输入用户名 (3-50个字符)" 
            required
            minlength="3"
            maxlength="50"
          />
        </div>
        
        <div class="form-group">
          <label for="email">邮箱</label>
          <input 
            type="email" 
            id="email" 
            v-model="form.email" 
            placeholder="请输入邮箱" 
            required
          />
        </div>
        
        <div class="form-group">
          <label for="password">密码</label>
          <input 
            type="password" 
            id="password" 
            v-model="form.password" 
            placeholder="请输入密码 (至少6位)" 
            required
            minlength="6"
          />
        </div>
        
        <div class="form-group">
          <label for="confirmPassword">确认密码</label>
          <input 
            type="password" 
            id="confirmPassword" 
            v-model="form.confirmPassword" 
            placeholder="请再次输入密码" 
            required
          />
        </div>
        
        <button type="submit" class="register-btn" :disabled="loading">
          {{ loading ? '注册中...' : '注册' }}
        </button>
      </form>
      
      <div class="register-footer">
        <span>已有账号？</span>
        <router-link to="/login" class="login-link">立即登录</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/api/client'
import Toastify from 'toastify-js'

export default {
  name: 'RegisterView',
  data() {
    return {
      form: {
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      loading: false,
      error: ''
    }
  },
  methods: {
    async handleRegister() {
      // 验证密码一致性
      if (this.form.password !== this.form.confirmPassword) {
        this.error = '两次输入的密码不一致'
        this.showToast(this.error, 'error')
        return
      }
      
      this.loading = true
      this.error = ''
      
      try {
        const result = await apiClient.register({
          username: this.form.username,
          email: this.form.email,
          password: this.form.password
        })
        
        if (result.success) {
          // 保存token和用户信息
          apiClient.setToken(result.data.token)
          localStorage.setItem('user', JSON.stringify(result.data.user))
          
          // 显示成功提示
          this.showToast('注册成功！', 'success')
          
          // 跳转到主页
          this.$router.push('/')
        } else {
          this.error = result.error || '注册失败'
          this.showToast(this.error, 'error')
        }
      } catch (error) {
        this.error = error.message || '注册失败，请稍后重试'
        this.showToast(this.error, 'error')
      } finally {
        this.loading = false
      }
    },
    
    showToast(message, type = 'info') {
      Toastify({
        text: message,
        duration: 3000,
        gravity: "top",
        position: "right",
        style: {
          background: type === 'success' ? "#4CAF50" : type === 'error' ? "#F44336" : "#2196F3"
        }
      }).showToast()
    }
  }
}
</script>

<style scoped>
.register-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.register-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.register-header h1 {
  color: #333;
  margin-bottom: 10px;
  font-size: 2em;
}

.register-header p {
  color: #666;
  font-size: 1em;
}

.register-form {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
}

.register-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.3s;
}

.register-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.register-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.register-footer {
  text-align: center;
  color: #666;
}

.login-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  margin-left: 5px;
}

.login-link:hover {
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .register-card {
    padding: 30px 20px;
  }
  
  .register-header h1 {
    font-size: 1.5em;
  }
}
</style>
